<template>
    <div class="hidden lg:block">
        <!-- Profile dropdown -->
        <Menu
            as="div"
            class="relative">
            <MenuButton class="-m-1.5 flex p-1.5 cursor-pointer">
                <span class="sr-only">{{ $t('base.openUserMenu') }}</span>
                <div class="relative text-xl font-medium font-family-squada-one text-white hover:text-primary-red cursor-pointer">
                    Service
                </div>
            </MenuButton>
            <Transition
                enter-active-class="transition ease-out duration-100"
                enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75"
                leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95">
                <MenuItems
                    class="absolute right-0 z-10 mt-2.5 origin-top-right rounded-md bg-white dark:bg-gray-700 py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                    <NuxtLink
                        v-for="menuItem in menuItems"
                        :key="menuItem.slug"
                        :to="$localePath(menuItem.url ?? '')"
                        class="font-semibold text-gray-900">
                        <BaseMenuItem>
                            {{ menuItem.name }}
                        </BaseMenuItem>
                    </NuxtLink>
                </MenuItems>
            </Transition>
        </Menu>
    </div>
</template>

<script setup lang="ts">
import type {WebsiteMenuItem} from "~/types/websiteMenu"

const props = defineProps<{
    menuItems: WebsiteMenuItem[] | null
}>()
</script>
